import { render, staticRenderFns } from "./CatalogFilterStatusBar.vue?vue&type=template&id=261b0d56"
import script from "./CatalogFilterStatusBar.vue?vue&type=script&lang=ts"
export * from "./CatalogFilterStatusBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports